import React, { useState, createContext, useContext, useMemo } from "react";

const PlansContext = createContext(null);
export const usePlansContext = () => useContext(PlansContext);

export const PlansProvider = ({ children }) => {
  const [loadingSumAssured, setLoadingSumAssured] = useState(false);
  const [loadingSavingTime, setLoadingSavingTime] = useState(false);
  const [loadingReturnPercentage, setLoadingReturnPercentage] = useState(false);
  const [loadingQuote, setLoadingQuote] = useState(false);
  const [loadingPaymentFrequency, setLoadingPaymentFrequency] = useState(false);
  const [loadingBanks, setLoadingBanks] = useState(true);

  const isLoadingData = useMemo(() => {
    return loadingSavingTime || loadingReturnPercentage || loadingQuote || loadingPaymentFrequency;
  }, [loadingSavingTime, loadingReturnPercentage, loadingQuote, loadingPaymentFrequency]);

  const contextValue = {
    loadingSavingTime,
    loadingReturnPercentage,
    loadingQuote,
    isLoadingData,
    loadingPaymentFrequency,
    loadingSumAssured,
    loadingBanks,
    setLoadingSavingTime,
    setLoadingReturnPercentage,
    setLoadingQuote,
    setLoadingPaymentFrequency,
    setLoadingSumAssured,
    setLoadingBanks,
  };

  return (
    <PlansContext.Provider value={contextValue}>
      {children}
    </PlansContext.Provider>
  );
};
